import React from 'react'
import {AiOutlinePhone} from 'react-icons/ai'
import {BiMailSend} from 'react-icons/bi'

const Footer = () => {
  return (
    <div className='w-full'>
      <div className='justify-center flex mx-auto max-w-[1450px] bg-white py-20'>
          <div className='text-center'>
            <h2 className='text-3xl sm:text-4xl font-semibold pb-10'>Skontaktuj się z nami</h2>
            <div className='grid md:grid-cols-2'>

              <div>
                <h3 className='text-xl font-semibold'>Krzysztof Sikora</h3>
                <div className='flex pt-2'>
                    <AiOutlinePhone size={25}/>
                    <p className='pl-2'>krzystof.sikora@oniko.pl</p>
                </div>
                <div className='flex pt-1'>
                  <BiMailSend size={25}/>
                  <p className='pl-2'>530-750-047</p>
                </div>
              </div>

              <div className='pt-10 md:pt-0'>
                <h3 className='text-xl font-semibold'>Łukasz Onichimowski</h3>
                <div className='flex pt-2'>
                    <AiOutlinePhone size={25}/>
                    <p className='pl-2'>lukasz.onichimowski@oniko.pl</p>
                </div>
                <div className='flex pt-1'>
                  <BiMailSend size={25}/>
                  <p className='pl-2'>530-750-124</p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  )
}

export default Footer